export class LetterResponse {
  constructor(public letterName: string,
              public letterContent: string,
              public mimeType: string,
              public letterSize: string,
              public creationTimestamp?: string
  ) {}
}
